import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Прокручивает страницу в верх при каждой смене маршрута.
 * Используется внутри <BrowserRouter>. Без поведения 'smooth' —
 * чтобы переход выглядел мгновенным (как у обычной навигации браузера).
 */
export default function ScrollToTopOnNav() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Если есть якорь (#section) — даём браузеру самому прокрутить к нему
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
